Namespace 'AccountSettings.ConversationAttributes'

class AccountSettings.ConversationAttributes.HierarchicalTagsMetadata extends Backbone.Model

  levelPrefix: 'level_'
  levelRegex: new RegExp('^level_\\d+$', 'g')
  digitRegex: new RegExp('\\d+$', 'g')

  toJSON: =>
    json = super()
    @getLevels().forEach((level, index) => json["#{@levelPrefix}#{index + 1}"] = level)
    json

  validate: ->
    @_validateKeys(@attributes, @levelRegex)

  getLevels: =>
    @_levelNames(@attributes, @levelPrefix, @levelRegex, @digitRegex)
      .map((levelName) => @attributes[levelName] || {description: ''})

  _levelNames: (attrs, levelPrefix, levelRegex, digitRegex) ->
    levels = Object.getOwnPropertyNames(attrs)
      .filter((name) -> name.match(levelRegex))
      .map((name) -> parseInt(name.match(digitRegex)[0]))

    _.map(_.range(Math.min(levels...), Math.max(levels...) + 1), (n) -> "#{levelPrefix}#{n}")

  _validateKeys: (attrs, regex) ->
    unless _.every(Object.getOwnPropertyNames(attrs), (name) -> name.match(regex))
      return {
        success: false
        messages: ['Invalid metadata key']
      }
    {
      success: true
      messages: []
    }
